export default __webpack_public_path__ + "static/stockholm-babc54779e0ee49fc10499a4ba17854e.jpg";